import { render } from "./google.vue?vue&type=template&id=447a2457"
import script from "./google.vue?vue&type=script&lang=js"
export * from "./google.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/resources/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__